import { render, staticRenderFns } from "./IndexVuetify.vue?vue&type=template&id=2775180f&scoped=true"
import script from "./IndexVuetify.vue?vue&type=script&lang=js"
export * from "./IndexVuetify.vue?vue&type=script&lang=js"
import style0 from "./IndexVuetify.vue?vue&type=style&index=0&id=2775180f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2775180f",
  null
  
)

export default component.exports